/** Shopify CDN: Minification failed

Line 107:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 108:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 118:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 119:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 127:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 133:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 139:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 143:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 150:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 151:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 92:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 93:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 112:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 118:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 128:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 135:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 136:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 77:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 78:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 97:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 103:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 113:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 120:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 121:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 62:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 82:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 88:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 105:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 47:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 67:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 73:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 79:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 90:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 91:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 32:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 52:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 64:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 17:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 18:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 28:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 37:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 60:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:6 Transforming const to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let variantSectionUrl = `${window.routes.root_url}/variants/${variantId}/?section_id=pickup-availability`;
      
      // remove double `/` in case shop might have /en or language in URL
      variantSectionUrl = variantSectionUrl.replace('//', '/');

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      this.querySelector('button').addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', () => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('pickup-availability--open');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      setScrollbarWidth();
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('pickup-availability--open');
      trapFocus(this);
    }
  });
}
